module.exports = __webpack_public_path__ + "static/media/nexo-banner-202507.87881eaa.png";